export const FETCH_SETTINGS = 'src/Setting/FETCH_SETTINGS';
export const UPDATE_SETTINGS = 'src/Setting/UPDATE_SETTINGS';
export const SETTINGS_ERROR = 'src/Setting/SETTINGS_ERROR';
export const SETTING_LOADING = 'src/Setting/SETTING_LOADING';
export const SET_CREDITS = 'src/Setting/SET_CREDITS';